// extracted by mini-css-extract-plugin
export default {"container":"AdditionalWagers_container__DXyHH","button":"AdditionalWagers_button__GWTUx"};